import React, { useState, useEffect, useContext } from 'react';
import { useHistory } from "react-router-dom";
import { makeStyles } from '@material-ui/core/styles';
import { AuthContext } from '../contexts/AuthContext';

import CssBaseline from '@material-ui/core/CssBaseline';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';

import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';

import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';

import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';

import Logo from '../assets/images/logo.png';

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
    padding:10
  },
}));

//Alert Container
function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

export default function SignIn() {

  const classes = useStyles();
  const history = useHistory();

  const { login, isAuthenticated, authError } = useContext(AuthContext);

  const [inputUsername, setUsername] = useState('');
  const [inputPassword, setPassword] = useState('');
  const [rememberMe, setRememberMe] = useState(false);
  const [open, setOpen] = useState(false);

  const handleChange = (event) => {
    setRememberMe(event.target.checked);
  };

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  const handelLogin = (e) => {
    e.preventDefault();
    login(inputUsername, inputPassword, rememberMe);
  }

  useEffect(() => {
    if(isAuthenticated) {
      history.push("/dashboard");
    }
  },[isAuthenticated]);
  
  useEffect(() => {
    if(authError) {
      setOpen(true);
    }
  },[authError]);

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <div className={classes.paper}>
        
        <img src={Logo} alt="PCS" style={{width: '100%', maxWidth:'70vw'}} />

        <Snackbar open={open} autoHideDuration={6000} onClose={handleClose} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
          <Alert severity="error">{authError}</Alert>
        </Snackbar>

        <form className={classes.form} noValidate onSubmit={handelLogin}>
          <TextField
            variant="outlined"
            margin="normal"
            value={inputUsername}
            required
            fullWidth
            type="text"
            id="username"
            label="Username"
            name="username"      
            autoFocus
            autoComplete="current-username"
            onChange={(e)=>setUsername(e.target.value)} />

          <TextField
            variant="outlined"
            margin="normal"
            value={inputPassword}
            required
            fullWidth
            name="password"
            label="Password"
            type="password"
            id="password"
            autoComplete="current-password"
            onChange={(e)=>setPassword(e.target.value)} />

          <FormControlLabel
            control={<Checkbox checked={rememberMe} onChange={handleChange} value="remember" color="primary" />}
            label="Remember me" />

          <Button type="submit" fullWidth variant="contained" color="primary" className={classes.submit}>
            Sign In
          </Button>

          {/* <Grid container>
            <Grid item xs>
              <Link href="#" variant="body2">
                {"Forgot password?"}
              </Link>
            </Grid>
            <Grid item>
              <Link href="#" variant="body2">
                {"Don't have an account? Sign Up"}
              </Link>
            </Grid>
          </Grid> */}
        </form>
      </div>
      <Box mt={8}>
        <Typography variant="body2" color="textSecondary" align="center">
          {`© 1992-${new Date().getFullYear()} Personalized Computer Systems, Inc.`}
        </Typography>
      </Box>
    </Container>
  );
}
